import { motion, useReducedMotion } from "framer-motion";
import { buildVine, LEAF, VEIN } from "@/components/theme/vine";

const GOLD = "#C6A56B"; // champagne gold
const VINE = buildVine();

function Vine({ className, delay = 0, reduce }) {
  return (
    <motion.svg
      viewBox="0 0 420 420"
      className={className}
      fill="none"
      stroke={GOLD}
      strokeLinecap="round"
      strokeLinejoin="round"
      style={{ transformOrigin: "100% 100%" }}
      animate={reduce ? undefined : { rotate: [0, 1.4, 0, -0.9, 0] }}
      transition={{ duration: 18, repeat: Infinity, ease: "easeInOut" }}
    >
      {VINE.stems.map((s, i) => (
        <motion.path
          key={`s${i}`}
          d={s.d}
          strokeWidth={s.w}
          strokeOpacity={0.75}
          initial={reduce ? false : { pathLength: 0 }}
          animate={{ pathLength: 1 }}
          transition={{ duration: 2.8, delay: delay + i * 0.45, ease: "easeInOut" }}
        />
      ))}
      {VINE.leaves.map((l, i) => (
        <g key={`l${i}`} transform={`translate(${l.x.toFixed(1)} ${l.y.toFixed(1)}) rotate(${l.ang.toFixed(1)}) scale(${l.s.toFixed(2)})`}>
          <motion.g
            initial={reduce ? false : { opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 1.4, delay: delay + 0.9 + i * 0.07 }}
          >
            <path d={LEAF} strokeWidth={1.1 / l.s} fill={GOLD} fillOpacity={0.1} strokeOpacity={0.8} />
            <path d={VEIN} strokeWidth={0.8 / l.s} strokeOpacity={0.5} />
          </motion.g>
        </g>
      ))}
      {VINE.dots.map((d, i) => (
        <motion.circle
          key={`d${i}`}
          cx={d.x}
          cy={d.y}
          r={d.r}
          fill={GOLD}
          stroke="none"
          fillOpacity={0.7}
          initial={reduce ? false : { opacity: 0, scale: 0.4 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 1, delay: delay + 2.6 + i * 0.2 }}
        />
      ))}
    </motion.svg>
  );
}

const glow = (a) => ({ background: `radial-gradient(closest-side, rgba(198,165,107,${a}), rgba(198,165,107,0))` });

// Latar berhias: cahaya champagne lembut + tanaman garis emas di dua pojok.
// mode "behind": di belakang isi halaman (akar halaman harus punya "relative isolate").
// mode "overlay": di atas halaman tapi memakai blend multiply, jadi tulisan tetap terbaca
//                 (dipakai untuk halaman yang latarnya diatur komponen lain).
export function Backdrop({ mode = "behind" }) {
  const reduce = useReducedMotion();
  const layer =
    mode === "overlay"
      ? "pointer-events-none fixed inset-0 z-[5] overflow-hidden mix-blend-multiply"
      : "pointer-events-none fixed inset-0 -z-10 overflow-hidden";
  return (
    <div aria-hidden="true" className={layer}>
      <div className="absolute -bottom-44 -right-44 h-[560px] w-[560px] rounded-full" style={glow(0.3)} />
      <div className="absolute -left-52 -top-52 h-[440px] w-[440px] rounded-full" style={glow(0.2)} />
      <Vine className="absolute bottom-0 right-0 w-[min(58vw,400px)] md:w-[min(38vw,500px)]" reduce={reduce} />
      <div className="absolute left-0 top-0 w-[min(30vw,200px)] rotate-180 md:w-[min(20vw,290px)]">
        <Vine className="block w-full" delay={0.7} reduce={reduce} />
      </div>
    </div>
  );
}

export default Backdrop;
